import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { SharedCheckout } from "../../components/checkout/shared-checkout";
import { useFlowPath } from "../../hooks/use-flow-path";
import { useCartState } from "../../store/use-cart-state";
import { useUserState } from "../../store/use-user-state";
import { configName } from "../config/config-name";
import { routes } from "../config/routes";

export const Checkout = () => {
  const history = useHistory();
  const flowPath = useFlowPath();
  const { t } = useTranslation();
  const { products, upsellAvailable, getTotalPrice } = useCartState();
  const { user } = useUserState();

  useEffect(() => {
    if (products.length === 0 || !user) {
      history.push(flowPath(routes.pickVoucher.raw()));
    }
  }, [products, user, history, flowPath]);

  const handleBack = () => {
    history.push(flowPath(upsellAvailable ? routes.pickUpsell.raw() : routes.pickVoucher.raw()));
  };

  return (
    <SharedCheckout
      configName={configName}
      title={t("cmsTranslations.free_packages.user_data_form.title")}
      description={t("cmsTranslations.free_packages.user_data_form.description")}
      onBack={handleBack}
      thankYouRoute={routes.thankYou}
      products={products}
      totalPrice={getTotalPrice()}
    />
  );
};
